export default {
  setTaxData(state, taxData) {
    state.taxData = taxData;
  }
}
